import type { IWordGame, IWordGameDetail } from '@/types/Data'
import type { IGetWordSearchGamesForAdmin, IWordGamePayload } from '@/types/Request'
import BaseService from '../BaseService'

export default class WordGameService extends BaseService {
  CreateWordGame(payload: IWordGamePayload) {
    return this.POST<string>(this.PATHS.CREATE_WORD_GAME, payload)
  }

  UpdateWordGame(payload: IWordGamePayload) {
    return this.POST<string>(this.PATHS.UPDATE_WORD_GAME, payload)
  }

  DeleteWordGame(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_WORD_GAME, { Id })
  }

  GetWordGameById(Id: string) {
    return this.GET<IWordGameDetail>(this.PATHS.GET_WORD_GAME_BY_ID, { Id })
  }

  GetWordSearchGamesForAdmin(payload: IGetWordSearchGamesForAdmin) {
    return this.GET<IWordGame[]>(this.PATHS.GET_WORD_SEARCH_GAMES_FOR_ADMIN, payload)
  }
}
